import { createAction } from 'redux-actions'

export const openDialog = createAction('OPEN_DIALOG')

export const closeDialog = createAction('CLOSE_DIALOG')

export const performAction = () => (dispatch, getState) => {
  const action = getState().dialog.params.action
  if (action) {
    action()
  }
  dispatch(closeDialog())
}



// WEBPACK FOOTER //
// ./src/actions/dialog.js